// extracted by mini-css-extract-plugin
export default {"roleTag":"_2f6AuAQv"};